// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"3a8284d7","402":"b8f9ccf3","715":"185b0b02","908":"7fc0c176"}[chunkId] + ".chunk.js";
};